export default "__VITE_ASSET__39560a48__"